export default __webpack_public_path__ + "static/media/frontOfficeOff.0b252871.svg";